export enum EnumProfilesTabs {
  Invoice = 1,
  Lead
}
